module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-4",
    class: [("_" + _vm.staging), {
      isDark: _vm.currentStage.isDark
    }]
  }, [(_vm.hideStagerTitle) ? _c('div', {
    staticClass: "auth__subtitle mb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.currentStage.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.current > 1 && _vm.hideStagerBar) ? _c('div', {
    staticClass: "stages"
  }, _vm._l((_vm.stages.slice(1, _vm.stages.length - 2)), function(stage, index) {
    return _c('div', {
      key: index,
      staticClass: "stage dflex",
      class: {
        _current: _vm.current >= stage.stage
      }
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_meta"
  }, [(_vm.currentStage.subtitle) ? _c('div', {
    staticClass: "_subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentStage.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentStage.cta1) ? _c('div', {
    staticClass: "cta cta1"
  }, [_c('v-btn', {
    staticClass: "px-2",
    style: (("background-color: " + (_vm.currentStage.cta1.color))),
    attrs: {
      "depressed": "",
      "round": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.handleCTA(_vm.currentStage.cta1.action)
      }
    }
  }, [_c('strong', [_vm._v("\n          " + _vm._s(_vm.currentStage.cta1.title) + "\n        ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.currentStage.cta2) ? _c('div', {
    staticClass: "cta cta2"
  }, [_c('v-btn', {
    staticClass: "no-Btn-bg transparent",
    attrs: {
      "ripple": false,
      "depressed": "",
      "round": ""
    }
  }, [_c('strong', [_vm._v("\n          " + _vm._s(_vm.currentStage.cta2.title) + "\n        ")])])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27eccaf9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/stager.vue
// module id = 1655
// module chunks = 180